<template>
  <AccessRequest
    entityLabel="Dust Control Operating Permit"
    entityName="Construction Project"
    :include-help-text="false"
    request-text-label="Project Name"
  >
    <template #requestTextFields>
      <FormKit label="Project Name" name="requestText" type="text" validation="required:trim|length:0,255" />
      <FormKit label="Permit Number" name="cpPermitNumber" type="text" validation="required|length:0,50"
    /></template>
  </AccessRequest>
</template>

<script lang="ts">
import { FormKit } from "@formkit/vue";
import { defineComponent } from "vue";
import AccessRequest from "./AccessRequest.vue";

export default defineComponent({
  name: "ConstructionProjectAccessRequest",
  components: {
    AccessRequest,
  },
  setup() {
    return {};
  },
});
</script>
